import React, { FC, useState, useEffect } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import Address from "shared/Address";
import AddressComponent from "components/Address";
import { AddressType } from "data/types";
import address from "data/empty/address.json";
import Modal from "shared/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddress,
  addAddress,
  updateAddress,
  primaryAddress,
  deleteAddress,
} from "actions/addressActions";
import emptyAddress from "data/empty/address.json";
import { RootState } from "store";
import { RefreshIcon } from "@heroicons/react/solid";
import ButtonSecondary from "shared/Button/ButtonSecondary";

export interface AccountPageProps {
  className?: string;
}

const AccountAddress: FC<AccountPageProps> = ({ className = "" }) => {
  const dispatch = useDispatch();
  const { loading, addresses } = useSelector(
    (state: RootState) => state.addressList
  );

  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<AddressType>(address);
  const [modify, setModify] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [deletedAddress, setDeletedAddress] = useState<{
    id: string;
    name: string;
  }>({ id: "", name: "" });

  const handleModifying = (e: AddressType) => {
    dispatch(updateAddress(e));
    setOpen(!open);
  };

  const handleSubmit = (e: AddressType) => {
    dispatch(addAddress(e));
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(getAddress());
  }, []);

  const handleDeleteOpen = () => {
    setOpenDelete(!openDelete);
  };

  const handleOpen = () => {
    setOpen(!open);
    setModify(false);
    setData(emptyAddress);
  };

  const handleModify = (id: string) => {
    const theAddress = addresses.find(
      (address: AddressType) => address._id === id
    );
    setOpen(!open);
    setModify(true);
    if (theAddress) setData(theAddress);
  };

  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Akun</title>
      </Helmet>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <div className="flex flex-wrap justify-between">
            <h2 className="text-3xl font-semibold mb-3 ">Alamat Tersimpan</h2>
            <ButtonPrimary onClick={handleOpen} className="w-auto">
              Tambah Alamat
            </ButtonPrimary>
          </div>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div>
            {loading && (
              <RefreshIcon className="animate-spin h-6 w-6 mx-auto" />
            )}{" "}
            {addresses &&
              addresses.map((address: AddressType) => {
                return (
                  <Address
                    key={address._id}
                    address={address}
                    handleModify={() => handleModify(address._id as string)}
                    handlePrimary={(e) => {
                      dispatch(primaryAddress(e));
                    }}
                    handleDelete={(e) => {
                      setOpenDelete(true);
                      setDeletedAddress({ id: e._id as string, name: e.name });
                    }}
                  />
                );
              })}
          </div>
        </div>
      </CommonLayout>
      <Modal open={open} handleOpen={handleOpen} title="Tambahkan Alamat">
        <AddressComponent
          dataz={data}
          handleSubmit={handleSubmit}
          handleModify={handleModifying}
          handleClose={handleOpen}
          modify={modify}
        />
      </Modal>
      <Modal
        open={openDelete}
        handleOpen={handleDeleteOpen}
        title={`Hapus Alamat`}
      >
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        <h1 className="mt-3  text-neutral-900 dark:text-white text-xl">
          Hapus Alamat <span className="font-bold">{deletedAddress.name}</span>{" "}
          ?
        </h1>
        <div className="mt-6">
          <ButtonSecondary onClick={handleDeleteOpen} className="mr-3">
            Batal
          </ButtonSecondary>
          <ButtonPrimary
            onClick={() => {
              setOpenDelete(!openDelete);
              dispatch(deleteAddress(deletedAddress.id));
            }}
          >
            Hapus
          </ButtonPrimary>
        </div>
      </Modal>
    </div>
  );
};

export default AccountAddress;
